// extracted by mini-css-extract-plugin
module.exports = {"progress":"ProgressCell_progress__3-L9G","value":"ProgressCell_value__1g_zx","bar":"ProgressCell_bar__2xzAm"};